import React, {FC} from 'react';
import {
  ProcessDiagramIds,
  TaskGridIconsTitles, ZoomGridOptions
} from '../../../../constants/tasks';
import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import {Tooltip} from '@mui/material';

type TaskGridControlsProps = {
  zoomToElement: (id: string, scale: number) => void,
  zoomOut: (step: number) => void,
  zoomIn: (step: number) => void
}

const TaskGridControls: FC<TaskGridControlsProps> = ({
  zoomToElement, zoomOut, zoomIn
}) => (
  <div className="tasks-grid_tools">
    <Tooltip title={TaskGridIconsTitles.TO_ELEMENT}>
      <IconButton
        className="icon-button"
        onClick={() => zoomToElement(
            ProcessDiagramIds.END,
            ZoomGridOptions.INITIAL_SCALE
        )}
      >
        <GpsFixedIcon className="icon" fontSize="medium" />
      </IconButton>
    </Tooltip>

    <Tooltip title={TaskGridIconsTitles.ZOOM_OUT}>
      <IconButton
        className="icon-button"
        onClick={() => zoomOut(ZoomGridOptions.ZOOM_STEP)}
      >
        <RemoveCircleIcon className="icon" fontSize="medium" />
      </IconButton>
    </Tooltip>

    <Tooltip title={TaskGridIconsTitles.ZOOM_IN}>
      <IconButton
        className="icon-button"
        onClick={() => zoomIn(ZoomGridOptions.ZOOM_STEP)}
      >
        <AddCircleIcon className="icon" fontSize="medium" />
      </IconButton>
    </Tooltip>
  </div>
);

export default TaskGridControls;
